import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import classnames from 'classnames/bind'
import { random } from 'lodash-es'

// Libs
import useSize from '@react-hook/size'

// Components
// import Image from '@/components/common/Image'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface IProps {
  onChange: (callback: any) => void
  amount: number
}

interface IEmoji {
  no: number
  rotationAngle: number
  xAxis: number
  yAxis: number
  size: number
}

const emojiMaxSize = 50

const HorizontalEmoji = (props: IProps) => {
  const { onChange, amount } = props
  const horizontalEmojiAreaRef = useRef(null)
  const [width] = useSize(horizontalEmojiAreaRef)
  const displayWidth = width < emojiMaxSize ? emojiMaxSize : width
  const displayHeight = 80
  const [emojiList, setEmojiList] = useState<IEmoji[]>([])

  const emojiContainer: any = typeof window === 'undefined' ? null : document.getElementById('room')

  useEffect(() => {
    onChange(handleAddHorizontalBalloon())
  }, [amount])

  const handleAddHorizontalBalloon = () => {
    const minNo = 0
    const maxNo = 11
    const minSize = 40
    const maxSize = emojiMaxSize
    const minAngle = -50
    const maxAngle = 50
    const minXAxis = 0
    const maxXAxis = displayWidth - maxSize
    const minYAxis = 0
    const maxYAxis = displayHeight - maxSize

    setEmojiList([
      ...emojiList,
      {
        no: random(minNo, maxNo),
        rotationAngle: random(minAngle, maxAngle),
        xAxis: random(minXAxis, maxXAxis),
        yAxis: random(minYAxis, maxYAxis),
        size: random(minSize, maxSize),
      },
    ])
  }

  return (
    <>
      {/* 不用 createPortal 的話會在 room-action 底下，但 ChatInput 也在 room-action，他的 postion 要對應 room-action */}
      {/* 但 horizontalEmoji 不能對應 room-action，所以透過 createPortal 掛在更外層*/}
      {ReactDOM.createPortal(
        <div ref={horizontalEmojiAreaRef} className={cx('horizontal-balloon')}>
          {emojiList.map((balloon: IEmoji, index: number) => (
            <div
              key={index}
              className={cx('horizontal-balloon__object')}
              style={{
                transform: `translate3d(${balloon.xAxis}px, ${balloon.yAxis}px, 0) rotate(${balloon.rotationAngle}deg)`,
                width: balloon.size,
                height: balloon.size,
              }}
            >
              <img src={`/images/svg/emoji_${balloon.no}.svg`} />
            </div>
          ))}
        </div>,
        emojiContainer,
      )}
    </>
  )
}

export default HorizontalEmoji
